import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=d62b0dca&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d62b0dca')) {
      api.createRecord('d62b0dca', component.options)
    } else {
      api.reload('d62b0dca', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=d62b0dca&", function () {
      api.rerender('d62b0dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/pricehelp.vue"
export default component.exports